export function getStoredSiteOwnerSelection(userId: number): number | null {
  const storedValue = sessionStorage.getItem(getStoredSiteOwnerSelectionKey(userId));
  return storedValue ? Number(storedValue) : null;
}

export function setStoredSiteOwnerSelection(userId: number, siteOwnerId: number): void {
  sessionStorage.setItem(getStoredSiteOwnerSelectionKey(userId), String(siteOwnerId));
}

export function clearStoredSiteOwnerSelection(userId: number): void {
  sessionStorage.removeItem(getStoredSiteOwnerSelectionKey(userId));
}

function getStoredSiteOwnerSelectionKey(userId: number): string {
  return `ui.options.siteOwnerSelection.${userId}`;
}
